import { useEffect, useState } from "react";
import API_BASE_URL from "../../Constants"; // Ensure this is correct
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";

export const useNotifications = () => {
    const [notification, setNotification] = useState([]);

    useEffect(() => {
        console.log("Initializing WebSocket...");

        // Ensure WebSocket connects using HTTP-based SockJS URL
        console.log("Connecting to WebSocket:", `${API_BASE_URL}/ws`);
        // const socket = new SockJS(`${API_BASE_URL}/ws`);
        const socket = new SockJS(`${API_BASE_URL}/ws`, null, {
            transports: ["websocket", "xhr-streaming", "xhr-polling"],
        });
        const stompClient = new Client({
            webSocketFactory: () => socket,
            reconnectDelay: 5000,
            onConnect: () => {
                console.log("✅ Connected to WebSocket:", API_BASE_URL);
                stompClient.subscribe("/topic/notifications", (message) => {
                    console.log("📩 New Notification:", message.body);
                    setNotification((prev) => [...prev, JSON.parse(message.body)]);
                });
            },
            onStompError: (frame) => {
                console.error("🚨 STOMP Error:", frame);
            },
            onDisconnect: () => {
                console.warn("⚠️ Disconnected from WebSocket");
            }
        });

        stompClient.activate();

        return () => {
            console.log("Closing WebSocket...");
            stompClient.deactivate();
        };
    }, []);

    return {notification, setNotification};
};